import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { createAction } from 'redux-actions';
import { CALL_SERVICE } from '@instructure/redux-service-middleware';
import t from 'format-message';
import { SET_ERROR, SET_OUTCOMES, SET_ROOT_OUTCOME_IDS, SET_CONTEXT, SET_SCORING_METHOD } from "../../constants.js";
import { hasRootOutcomes, getChildrenToLoad, getContext } from "./selectors.js";
import { getConfig } from "../config/selectors.js";
import { getSelectedLaunchContext } from "../OutcomePicker/selectors.js";
export var setContext = createAction(SET_CONTEXT);
export var setOutcomes = createAction(SET_OUTCOMES);
export var setRootOutcomeIds = createAction(SET_ROOT_OUTCOME_IDS);
export var setError = createAction(SET_ERROR);
export var setScoringMethod = createAction(SET_SCORING_METHOD);
export var loadContext = function loadContext(host, jwt, contextUuid) {
  return function (dispatch, getState) {
    if (getContext(getState(), contextUuid)) {
      return Promise.resolve();
    }
    dispatch(setContext(_defineProperty({}, contextUuid, {
      loading: true
    })));
    return dispatch({
      type: CALL_SERVICE,
      payload: {
        service: 'outcomes',
        method: 'getContext',
        args: [host, jwt, contextUuid]
      }
    }).then(function (json) {
      return dispatch(setContext(_defineProperty({}, contextUuid, {
        loading: false,
        data: json
      })));
    }).catch(function (e) {
      return dispatch(setError(e));
    });
  };
};
export var loadRootOutcomes = function loadRootOutcomes() {
  return function (dispatch, getState, _arg, scope) {
    var _getConfig = getConfig(getState(), scope),
      contextUuid = _getConfig.contextUuid;
    var selectLaunchContext = getSelectedLaunchContext(getState(), scope);
    var context = (selectLaunchContext === null || selectLaunchContext === void 0 ? void 0 : selectLaunchContext.uuid) || contextUuid;
    if (hasRootOutcomes(getState(), scope)) {
      return Promise.resolve();
    }
    return dispatch(loadOutcomes(null)).then(function (json) {
      Object.assign(json.outcomes, {
        root: {
          id: 'root',
          title: t('Home'),
          description: t('Home level groups and outcomes'),
          child_ids: json.root_ids.map(function (id) {
            return id.toString();
          })
        }
      });
      dispatch(setOutcomes(_defineProperty({}, context, json.outcomes)));
      dispatch(setRootOutcomeIds(_defineProperty({}, context, json.root_ids)));
      return Promise.resolve();
    }).catch(function (e) {
      dispatch(setError(e));
    });
  };
};
export var loadMoreOutcomes = function loadMoreOutcomes(id) {
  return function (dispatch, getState, _arg, scope) {
    var _getConfig2 = getConfig(getState(), scope),
      contextUuid = _getConfig2.contextUuid;
    var selectLaunchContext = getSelectedLaunchContext(getState(), scope);
    var context = (selectLaunchContext === null || selectLaunchContext === void 0 ? void 0 : selectLaunchContext.uuid) || contextUuid;
    var idsToLoad = getChildrenToLoad(getState(), scope, id);
    if (idsToLoad.length === 0) {
      return Promise.resolve();
    }
    return dispatch(loadOutcomes(idsToLoad)).then(function (json) {
      dispatch(setOutcomes(_defineProperty({}, context, json.outcomes)));
      return Promise.resolve();
    }).catch(function (e) {
      dispatch(setError(e));
    });
  };
};
var loadOutcomes = function loadOutcomes(ids) {
  return function (dispatch, getState, _arg, scope) {
    var _getConfig3 = getConfig(getState(), scope),
      host = _getConfig3.host,
      jwt = _getConfig3.jwt,
      contextUuid = _getConfig3.contextUuid;
    var selectLaunchContext = getSelectedLaunchContext(getState(), scope);
    var context = (selectLaunchContext === null || selectLaunchContext === void 0 ? void 0 : selectLaunchContext.uuid) || contextUuid;
    return dispatch({
      type: CALL_SERVICE,
      payload: {
        service: 'outcomes',
        method: 'loadOutcomes',
        args: [host, jwt, context, ids]
      }
    }).then(function (json) {
      return Promise.resolve(json);
    });
  };
};